






import Vue from 'vue'
import FaceEntity from '@/entities/Face'
import ChildEntity from '@/entities/Child'

export default Vue.extend({
  props: {
    face: {
      type: Object as () => FaceEntity | ChildEntity,
      default: null
    }
  },
  computed: {
    src(): string {
      if (this.face) {
        if (this.face instanceof FaceEntity) {
          if (this.face.props.imageUrl) {
            return this.face.props.imageUrl
          } else {
            return '/static/icon/family/child/unknown.svg'
          }
        }
        if (this.face instanceof ChildEntity) {
          if (this.face.props.profileImage) {
            return this.face.props.profileImage
          }
        }
      }
      return ''
    }
  }
})
